"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectActions = void 0;
const init_1 = __importDefault(require("./init"));
const update_1 = __importDefault(require("./update"));
exports.selectActions = {
    init: init_1.default,
    update: update_1.default
};
